import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import * as S from "./styled";
import { useEffect } from "react";

export const Accordion = ({ items, defaultId }) => {
	const [openIndex, setOpenIndex] = useState(null);

	const toggleAccordion = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	useEffect(() => {
		if (defaultId) {
			const index = items.findIndex(
				(i) =>
					i.id.toString().toUpperCase() === defaultId.toString().toUpperCase(),
			);
			setOpenIndex(index === -1 ? null : index);
		}
	}, [defaultId, items]);

	return (
		<S.AccordionContainer>
			{items.map((item, index) => (
				<S.AccordionItem key={item.id}>
					<S.AccordionHeader
						onClick={() => toggleAccordion(index)}
						isOpen={openIndex === index}
					>
						<S.AccordionTitle>
							{item.icon}
							{item.title}
						</S.AccordionTitle>
						<S.AccordionIcon isOpen={openIndex === index}>
							<ChevronDown size={20} />
						</S.AccordionIcon>
					</S.AccordionHeader>
					<S.AccordionContent isOpen={openIndex === index}>
						{item.content}
					</S.AccordionContent>
					<S.Separator isOpen={openIndex === index} />
				</S.AccordionItem>
			))}
		</S.AccordionContainer>
	);
};
